<template>
  <div id="tmeka" v-if="!isInspection">
    <top/>
    <div id='layout'>
      <left/>
      <section id="content" :class="[isLeft ? 'showLeft' : 'hideLeft']">
        <Loading :show="$store.getters.isPageLoading" :class="[{inputShow: inputView}, {scrollContent: isScroll}]">
          <router-view/>
        </Loading>
        <LibraryInput @show="inputShow"/>
      </section>
    </div>
    <Footer v-if="$store.getters.ui === 1" />
    <umenu/>
    <ucalendar/>
    <popup/>
  </div>
  <div id="tmeka" v-else class="inspection">
    <div>
      <img src="/s3/inspection/inspection.jpeg" />
    </div>
    <div>
      <span>[점검시간]</span>
      <span>{{ this.$store.getters.inspection.time1 }}</span>
      <span> ~ </span>
      <span>{{ this.$store.getters.inspection.time2 }}</span>
    </div>
  </div>
</template>
<script>
import '@/assets/tmeka-icons/tmeka-icons.css'
import Loading from '@/components/base/Loading.vue'
import Footer from '@/components/layout/Footer.vue'
import LibraryInput from '@/components/library/LibraryInput'

export default {
  props: {},
  created () {},
  mounted () {
    this.$http.post('/api/getUI').then((e) => {
      console.log('getUI', e)
      if (e.success) {
        this.$store.commit('ui', e.data)
        if (e.data === 0) {
          document.documentElement.style.setProperty('--layoutH', 'calc(100vh - 55px)')
        } else {
          document.documentElement.style.setProperty('--layoutH', 'calc(100vh - 145px)')
        }
      }
    })
  },
  beforeDestroy () {},
  name: 'Tmeka',
  methods: {
    inputShow (e) {
      console.log(e)
      this.inputView = e
    }
  },
  data: function () {
    return {
      isView: true,
      inputView: false
    }
  },
  computed: {
    isInspection () {
      if (this.$store.getters.inspection) {
        return this.$store.getters.inspection.is
      } else {
        return false
      }
    },
    isScroll () {
      switch (this.$route.name) {
        case 'edit' :
        case 'bookedit' :
        case 'categoryedit' :
        case 'workedit' :
        case 'postedit' :
        case 'upenbeedit' :
        case 'post' :
        case 'publishing-agree' :
        case 'publishing-info' :
        case 'publishing-make' :
        case 'publishing-intro' :
        case 'publishing-bookpublishing' :
        case 'publishing-bookinfo' :
          return false
        default :
          return true
      }
    }
  },
  components: {
    Loading,
    LibraryInput,
    Footer
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/earlyaccess/nanumgothic.css');
@import url('https://fonts.googleapis.com/earlyaccess/nanummyeongjo.css');
@import url('https://cdn.jsdelivr.net/font-kopub/1.0/kopubdotum.css');
@import url('https://fonts.googleapis.com/earlyaccess/kopubbatang.css');
:root {
  --bg-default: #F9F9F9;
  --bg-white: #FFFFFF;

  --line-title: #404040;
  --line-base: #7f7f7f;
  --line-guide: #bfbfbf;

  --text-title: #404040;
  --text-base: #7f7f7f;
  --text-guide: #bfbfbf;

  --active: #00b0f0;
  --require: #c00000;
  --deactive: #7f7f7f;
  --disable: #EAEAEA;

  --button-type0: var(--active);
  --button-type1: var(--require);
  --button-type2: var(--deactive);
  --button-disable: var(--disable);

  --icon-base: #404040;
  --icon-over: #000000;
  --icon-active: var(--active);
  --icon-require: var(--require);
  --icon-disable: var(--disable);
  --icon-deactive: var(--text-guide);

  --bookW: 290px;
  --bookH: 250px;
  --bookWS: 30px;
  --bookHS: 40px;
  --postW: 400px;
  --postH: 140px;
  --postWS: 30px;
  --postHS: 40px;

  --layoutH: calc(100vh - 145px);
}
body {
  margin:0px auto;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  word-break: break-all;
  color: var(--text-base);
}
*:focus {
  outline: none;
}
a {
  text-decoration: none;
  white-space: nowrap;
}
a:visited {
  text-decoration: none;
  color: #0000EE;
}
a:hover {

}
a:focus{
  outline: none;
}
.rotate90 {
  transform: rotate(90deg);
}
.rotate180 {
  transform: rotate(180deg);
}
.rotate270 {
  transform: rotate(270deg);
}
input:focus,
textarea:focus {
  outline: none;
}
input::placeholder,
textarea::placeholder {
  color: var(--text-guide);
}
textarea {
  border: 0px;
  width: 100%;
  height: 100%;
  resize: none;
}
input::-ms-reveal, input::-ms-clear {
  display: none;
}
input[type=text], input[type=password], input[type=email] {
  flex: 1;
  border: 0px;
  padding: 0px 0px 0px 0px;
  height: 100%;
  width: 100%;
  background-color: inherit;
  font-size: 1em;
}
input[type=checkbox].checkbox {
  display: none;
}
input[type=checkbox].checkbox + label {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  cursor: pointer;
}
input[type=checkbox].checkbox + label::before {
  content: '';
  color: var(--line-base);
  position: absolute;
  line-height: 13px;
  width: 13px;
  height: 13px;
  border-radius:3px;
  border: 1px solid var(--line-base);
  left: 0px;
  text-align: center;
}
input[type=checkbox].checkbox:checked + label::before {
  content: '\2714';
}
#tmeka {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.whiteStyle {
  background-color: white;
  color: black;
}
.cursorButton {
  cursor:pointer;
}
.contentScorll {
  overflow-y: auto;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
}
ul {
  margin: 0px;
  padding: 0px;
}
button {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid;
  padding: 0px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
button.month {
  color: var(--text-base);
  background-color: var(--bg-white);
  border: 1px solid var(--line-base);
}
button.month:hover {
  color: var(--bg-white);
  background-color: var(--line-base);
  border: 1px solid var(--line-base);
}
button.active {
  color: var(--active);
  border-color: var(--active);
}
button.active:hover {
  color: var(--bg-white);
  background-color: var(--active);
}
button.deactive {
  color: var(--deactive);
  border-color: var(--deactive);
}
button.deactive:hover {
  color: var(--bg-white);
  background-color: var(--deactive);
}
button.deactive.disabled:hover {
  color: var(--deactive);
  background-color: rgba(0, 0, 0, 0);
}
button.in-deactive {
  color: var(--bg-white);
  background-color: var(--line-title);
  border: 1px solid var(--line-title);
}
button.in-deactive:hover {
  color: var(--text-title);
  background-color: var(--bg-white);
  border: 1px solid var(--line-title);
}
button.require {
  color: var(--require);
  border-color: var(--require);
}
button.require:hover {
  color: var(--bg-white);
  background-color: var(--require);
}
button.disable {
  color: var(--disable);
  border-color: var(--disable);
}
button.toogle.true {
  color: var(--bg-white);
  background-color: var(--active);
}
button.toogle.false {
  border: 1px solid var(--line-base);
  color: var(--text-base);
}
button.toogle.false:hover {
  background-color: var(--line-base);
  color: var(--bg-white);
}
.active {
  color: var(--active);
}
.guide {
  color: var(--text-guide);
}
.base {
  color: var(--text-base);
}
.title {
  color: var(--text-title);
}
.require {
  color: var(--require);
}
.disable {
  color: var(--disable);
}
.highlight {
  color: var(--bg-white);
}
#layout {
  width: 100%;
  /* height: calc(100vh - 55px); */
  height: var(--layoutH);
  display: inline-flex;
  flex-direction: row;
  overflow-y: hidden;
}
.Book + .Book {
  margin-left: var(--bookWS);
}
.Book {
  margin-bottom: var(--bookHS);
}
.Post + .Post {
  margin-left: var(--postWS);
}
.Post {
  margin-bottom: var(--postHS);
}
.genreStep {
  margin: 0 0px;
}
.bannerBox img, .onBannerBox img {
  width: 1570px;
  height: 250px;
}
.bannerBox, .onBannerBox {
  display: flex;
  overflow-x: hidden;
  min-height: 250px;
}
.right {
  margin-left: auto;
}
.left {
  margin-right: auto;
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 630px) {
  .leftOffBookListContent {
    width: var(--bookW);
  }
  .leftOffBookListContent .Book:nth-child(1n) {
    margin-left: 0px;
  }
  .bannerBox {
    width: var(--bookW);
  }
}
@media only screen and (min-width: 631px) and (max-width: 950px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
  .leftOffBookListContent .Book:nth-child(2n+1) {
    margin-left: 0px;
  }
  .bannerBox {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
}
@media only screen and (min-width: 951px) and (max-width: 1270px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
  .leftOffBookListContent .Book:nth-of-type(3n+1) {
    margin-left: 0px;
  }
  .bannerBox {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
}
@media only screen and (min-width: 1271px) and (max-width: 1590px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
  .leftOffBookListContent .Book:nth-of-type(4n+1) {
    margin-left: 0px;
  }
  .bannerBox {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
}
@media only screen and (min-width: 1591px) {
  .leftOffBookListContent {
    width: calc(var(--bookW) * 5 + var(--bookWS) * 4);
  }
  .leftOffBookListContent .Book:nth-of-type(5n+1) {
    margin-left: 0px;
  }
  .bannerBox {
    width: calc(var(--bookW) * 5 + var(--bookWS) * 4);
  }
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 920px) {
  .leftOnBookListContent {
    width: var(--bookW);
  }
  .leftOnBookListContent .Book:nth-child(1n) {
    margin-left: 0px;
  }
  .onBannerBox {
    width: var(--bookW);
  }
}
@media only screen and (min-width: 921px) and (max-width: 1230px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
  .leftOnBookListContent .Book:nth-child(2n+1) {
    margin-left: 0px;
  }
  .onBannerBox {
    width: calc(var(--bookW) * 2 + var(--bookWS));
  }
}
@media only screen and (min-width: 1231px) and (max-width: 1560px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
  .leftOnBookListContent .Book:nth-of-type(3n+1) {
    margin-left: 0px;
  }
  .onBannerBox {
    width: calc(var(--bookW) * 3 + var(--bookWS) * 2);
  }
}
@media only screen and (min-width: 1561px) {
  .leftOnBookListContent {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
  .leftOnBookListContent .Book:nth-of-type(4n+1) {
    margin-left: 0px;
  }
  .onBannerBox {
    width: calc(var(--bookW) * 4 + var(--bookWS) * 3);
  }
}
/* ------------------------------------------------------------------------- */
@media only screen and (max-width: 830px) {
  .leftOffPostListContent {
    width: var(--postW);
  }
}
@media only screen and (min-width: 830px) and (max-width: 1260px) {
  .leftOffPostListContent {
    width: calc(var(--postW) * 2 + var(--postWS));
  }
}
@media only screen and (min-width: 1260px) {
  .leftOffPostListContent {
    width: calc(var(--postW) * 3 + var(--postWS) * 2);
  }
}
@media only screen and (max-width: 1120px) {
  .leftOnPostListContent {
    width: var(--postW);
  }
  .leftOnPostListContent .Post:nth-child(1n) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1120px) and (max-width: 1550px) {
  .leftOnPostListContent {
    width: calc(var(--postW) * 2 + var(--postWS));
  }
  .leftOnPostListContent .Post:nth-child(2n+1) {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1550px) {
  .leftOnPostListContent {
    width: calc(var(--postW) * 3 + var(--postWS) * 2);
  }
  .leftOnPostListContent .Post:nth-child(3n+1) {
    margin-left: 0px;
  }
}
#content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-default);
}
#content .body {
  height: 100%;
}
#content .inputShow {
  height: calc(100% - 190px);
  overflow-y: hidden;
}
.content {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  height: 100%;
}
.scrollContent {
  overflow-y: auto;
}
.hideLeft {
  width: 100vw;
}
.showLeft{
  width: calc(100vw - 290px);
}
.hide {
  display: none !important;
}
.show {
  display: flex;
}
.list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
}
.inspection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.inspection > div:last-child {
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/Tmeka.vue